let DateUtils = {
        StringToDate: (str, fmt) => {
            if ((str + "").length === 10) {
                str = str *1000;
            }
            let date = new Date(str);
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
            }
            let o = {
                'M+': date.getMonth() + 1,
                'd+': date.getDate(),
                'h+': date.getHours(),
                'm+': date.getMinutes(),
                's+': date.getSeconds()
            };
            for (let k in o) {
                if (new RegExp(`(${k})`).test(fmt)) {
                    let str = o[k] + '';
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : DateUtils.padLeftZero(str));
                }
            }
            return fmt;
        },

        padLeftZero: (str) => {
            return ('00' + str).substr(str.length);
        }
    }
;
export default DateUtils;